import { SelectItem } from 'primeng/api';

export enum BillFrequencyType {
  Daily = 'DAILY',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
}

export const BILL_FREQUENCY_TYPES: SelectItem[] = [
  { label: 'Daily', value: BillFrequencyType.Daily },
  { label: 'Weekly', value: BillFrequencyType.Weekly },
  { label: 'Monthly', value: BillFrequencyType.Monthly },
];
